import type { ReactNode } from "react";

import { Box, Text } from "~/ui";

interface TruncatingTitleProps {
  title: string;
  secondary?: ReactNode;
  size?: "sm" | "lg";
}

export const TruncatingTitle = ({ title, secondary, size = "sm" }: TruncatingTitleProps) => (
  <Box className="assistant-truncating-title" style={{ width: 0, flexGrow: 1 }}>
    <Text size={size} fw={600} c="gray.8" truncate>
      {title}
    </Text>
    {secondary !== undefined && (
      <Text size="xs" c="dimmed">
        {secondary}
      </Text>
    )}
  </Box>
);
